import { jsx as t } from "react/jsx-runtime";
import r from "next/link.js";
import { tv as i } from "tailwind-variants";
import { I as l } from "./chunks/index-CgDhSQ6a.js";
const d = i({
  slots: {
    base: [
      "aspect-[4/3]",
      "block",
      "isolate",
      "overflow-hidden",
      "relative",
      "rounded-tl-2xl",
      "rounded-tr-2xl",
      "w-full"
    ],
    image: [
      "backface-hidden",
      "duration-300",
      "hover:scale-105",
      "object-cover",
      "object-top",
      "transition-transform"
    ]
  }
}), { base: m, image: c } = d(), x = ({ alt: a, className: o, href: e, onClick: s, src: n }) => /* @__PURE__ */ t(
  e ? r : "div",
  {
    "aria-hidden": e ? !0 : void 0,
    className: m({ class: o }),
    href: e,
    onClick: s,
    tabIndex: e ? -1 : void 0,
    children: /* @__PURE__ */ t(
      l,
      {
        alt: e ? "" : a,
        className: c(),
        fill: !0,
        src: n,
        width: 475
      }
    )
  }
);
export {
  x as default
};
